import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { IUseAmlVerified } from "./types";
import useAmlStatus from "../useAmlStatus";
import useAdvisor from "../useAdvisor";

const useAmlVerified: IUseAmlVerified = () => {
  const { data, error } = useAmlStatus();
  const pathname = usePathname();
  const [amlVerified, setAmlVerified] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const { isAdvisor } = useAdvisor();

  useEffect(() => {
    if (pathname?.startsWith("/internal")) {
      setAmlVerified(true);
      setLoading(false);
    } else {
      if (data?.statusCode) {
        if (data?.statusCode.toLowerCase() === "ok") {
          setAmlVerified(true);
        } else {
          if (isAdvisor) {
            setLoading(false);
            return;
          }
          if (data.statusCode.toLowerCase() === "expired" || data.statusCode.toLowerCase() === "doesnotexist") {
            setRedirectUrl("/aml/form");
          } else if (data.statusCode.toLowerCase() === "awaitingenhancedcontrol") {
            setRedirectUrl("/aml/waiting-control");
          } else if (data.statusCode.toLowerCase() === "awaitingenhancedcontrolpreviousok") {
            setAmlVerified(true);
          } else if (data.statusCode.toLowerCase() === "rejected") {
            setRedirectUrl("/aml/form");
          } else {
            // unknown aml status
            setRedirectUrl("/aml/form");
          }
        }
        setLoading(false);
      }
    }
  }, [data, amlVerified, isAdvisor, pathname]);

  return { amlVerified, renewSoon: data?.renewSoon, redirectUrl, error, loading };
};

export default useAmlVerified;
